import {del, get, post, put, putFormData} from "./RestClient"
import {postFormData} from "@/RestClient";
import * as queryString from "querystring";
import Encoding from 'encoding-japanese';
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters("client", ["company"]),
    companyId () {
      return this.company.id
    }
  },
  methods: {
    // System
    loadConsts (lang) {
      return this.getRequest(`/consts?lang=${lang || 'ja'}`, {}, res => {
        const consts = res.data;
        return this.getRequest(`/consts?service=connect&lang=${lang || 'ja'}`, {}, res => {
          this.dispatch("system", "updateConsts", {consts: {...consts, ...res.data}});
        })
      })
    },
    saveInquiry(username, email, type, detail) {
      return this.postRequest("/inquiry", {
        username,
        email,
        type,
        detail
      });
    },
    logout () {
      this.$auth.logout({
        returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URL || `${window.location.origin}`
      });
      this.dispatch("user", "clearUser", {});
    },
    logoutForUnsubscribe () {
      this.$auth.logoutForUnsubscribe();
      this.dispatch("user", "clearUser", {});
    },
    postFile (fileName) {
      const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      return this.postRequest("/data", {name: fileName, extension: ext});
    },
    uploadImageFile (url, file) {
      const fileName = file.name;
      let ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      if (ext === "jpg") {
        ext = "jpeg"
      }
      return this.putFormDataRequest(url, file, `image/${ext}`);
    },
    postFileData (file, isPrivate) {
      if (file.name.length > 60) {
        const fileNameIndex = file.name.lastIndexOf(".")
        const ext = file.name.substring(fileNameIndex + 1)
        const name = file.name.substring(0, 60 - ext.length)
        const blob = file.slice(0, file.size, file.type)
        file = new File([blob], `${name}.${ext}`, {type: file.type})
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("isPrivate", isPrivate ? '1' : '0')
      return this.postFormDataRequest("/data", formData, "multipart/form-data");
    },
    // User
    loadUser (isClient = false) {
      return this.getRequest("/auth", {}, async (res) => {
        if (isClient) {
          const business = await this.getRequest(`/users/${res.data.id}/business`)
          res.data.business = business.data
          this.dispatch("client", "updateBusiness", {business: business.data});
          this.loadCompany(res.data.business.company)
        } else {
          const userCompetition = await this.getRequest(`/users/${res.data.id}/competition`)
          res.data.competition = userCompetition.data
          const userRequirement = await this.getRequest(`/users/${res.data.id}/requirement`)
          res.data.requirement = userRequirement.data
          const userPr = await this.getRequest(`/users/${res.data.id}/pr`)
          res.data.pr = userPr.data
          const userDetail = await this.getRequest(`/users/${res.data.id}/detail`)
          res.data.detail = userDetail.data
        }
        this.dispatch("user", "updateUser", {user: res.data});
        return res.data
      })
    },
    loadCompany (id) {
      return this.getRequest(`/companies/${id}`, {}, res => {
        this.dispatch("client", "updateCompany", {company: res.data});
      })
    },
    loadCandidateUser (id) {
      return this.getRequest(`/client/users/${id}`, {}, res => {
        res.data.id = id
        this.dispatch("client", "updateCandidateUser", {user: res.data});
      })
    },
    loadNotifications (id) {
      return this.getRequest(`/users/${id}/notifications`, {}, res => {
        this.dispatch("user", "updateNotifications", {notifications: res.data.notifications})
      })
    },
    saveUserNotificationIsRead(id, notificationId, isRead) {
      return this.putRequest(`/users/${id}/notifications/${notificationId}`, {isRead: isRead}, () => {
        this.dispatch("user", "updateNotificationsIsRead");
      })
    },
    async loadClientUser (id) {
      const response = await this.getRequest(`/client/users/${id}`, {})
      return response.data
    },
    async loadCandidateJobs(candidateId, onlyDisclosed = false) {
      const response = await this.getRequest(`/client/jobs`, {candidateId, onlyDisclosed})
      return response.data.jobs
    },

    // 法人側のemail認証に利用、要検討
    // saveEmail (id, email) {
    //   return this.putRequest(`/users/${id}`, {
    //     email
    //   }, res => {
    //     this.dispatch("user", "updateUser", {user: res.data})
    //   });
    // },
    // sendEmailVerify (id) {
    //   return this.postRequest(`/users/${id}/email-verification`);
    // },
    saveUser (id, user) {
      return this.putRequest(`/users/${id}`, {
        name: user.name,
        realName: user.realName,
        realNameKana: user.realNameKana,
        email: user.email,
        birthDate: user.birthDate,
        gender: user.gender,
        area: user.area,
        prefecture: user.prefecture,
        zipCode: user.zipCode,
        address: user.address,
        building: user.building,
        academicHistory: user.academicHistory,
        schoolName: user.schoolName,
        department: user.department,
        departmentDetail: user.departmentDetail,
        graduated: user.graduated,
        graduatedYear: user.graduatedYear,
        dataGoodAt: user.dataGoodAt,
        taskGoodAt: user.taskGoodAt,
        domainGoodAt: user.domainGoodAt,
        programmingLanguage: user.programmingLanguage,
        showProfile: user.showProfile
      }, res => {
        this.dispatch("user", "updateUser", {user: res.data})
      });
    },
    saveUserCandidateFirstAccessed (id, accessed, registerService) {
      return this.putRequest(`/users/${id}`, {
        candidateFirstAccessed: accessed,
        registerService: registerService
      }, res => {
        this.dispatch("user", "updateUser", {user: res.data})
      });
    },
    saveUserCandidate (id, userCandidate, languages, careers) {
      if (id == null) {
        return this.postRequest(`/candidates`, {
          introduction: userCandidate.introduction,
          salary: userCandidate.salary,
          partner: userCandidate.partner,
          qualification: userCandidate.qualification,
          emailSub: userCandidate.emailSub,
          isReceiveMail: userCandidate.isReceiveMail,
          isReceiveScout: userCandidate.isReceiveScout,
          languages: languages,
          currentJob: userCandidate.currentJob,
          careers: careers,
          preferredLocation: userCandidate.preferredLocation,
          noindexCompanies: userCandidate.noindexCompanies
        }, res => {
          this.dispatch("user", "updateUserCandidate", {userCandidate: res.data})
          this.dispatch("user", "updateUserCandidateLanguages", {languages: res.data.languages})
          this.dispatch("user", "updateUserCandidateCareers", {careers: res.data.careers})
        });
      } else {
        return this.putRequest(`/candidates/${id.id}`, {
          introduction: userCandidate.introduction,
          salary: userCandidate.salary,
          partner: userCandidate.partner,
          qualification: userCandidate.qualification,
          emailSub: userCandidate.emailSub,
          isReceiveMail: userCandidate.isReceiveMail,
          isReceiveScout: userCandidate.isReceiveScout,
          languages: languages,
          currentJob: userCandidate.currentJob,
          careers: careers,
          preferredLocations: userCandidate.preferredLocations,
          noindexCompanies: userCandidate.noindexCompanies
        }, res => {
          this.dispatch("user", "updateUserCandidate", {userCandidate: res.data})
          this.dispatch("user", "updateUserCandidateLanguages", {languages: res.data.languages})
          this.dispatch("user", "updateUserCandidateCareers", {careers: res.data.careers})
        });
      }
    },
    saveUserIcon (id, file) {
      const formData = new FormData();
      formData.append("file", file);
      return this.putFormDataRequest(`/users/${id}/upload-icon`, formData, file.type, (res) => {
        this.dispatch("user", "updateIcon", {icon: res.data.icon});
      })
    },
    saveUserCandidateIcon (id, file) {
      const formData = new FormData();
      formData.append("file", file);
      return this.putFormDataRequest(`/users/${id}/upload-image`, formData, file.type, (res) => {
        this.dispatch("user", "updateCandidateIcon", {icon: res.data.image});
      })
    },
    saveCompany (company) {
      if (company.id == null) {
        return this.postRequest(`/companies`, company, res => {
          this.dispatch("client", "updateCompany", {company: res.data})
        });
      } else {
        return this.putRequest(`/companies/${company.id}`, company, res => {
          this.dispatch("client", "updateCompany", {company: res.data})
        });
      }
    },
    saveCompanyIcon (id, file) {
      const formData = new FormData();
      formData.append("file", file);
      return this.putFormDataRequest(`/companies/${id}/upload-logo`, formData, file.type, (res) => {
        this.dispatch("client", "updateCompanyLogo", {logoUrl: res.data.logo});
      })
    },
    saveBusiness (user, business) {
      return this.putRequest(`/users/${user.id}/business`, business, res => {
        this.dispatch("client", "updateBusiness", {business: res.data})
      });
    },
    deleteUser (id, answer) {
      return this.delRequest(`/users/${id}`, {
        reason: answer.reason.select,
        reason_etc: answer.reason.other,
        improvements: answer.improvements,
        opinion: answer.opinion
      }, () => {
        this.logoutForUnsubscribe();
      })
    },
    sendEmailToVerify(userId){
      return this.postRequest(`/users/${userId}/email-verification`)
    },

    // Job
    createJob (param) {
      return this.postRequest(`/companies/${this.companyId}/jobs`, {
        ...param,
        name: param.name === "" ? null : param.name,
        image1: undefined,
        image2: undefined,
        image3: undefined,
        image_1: param.image1 ? param.image1.id : undefined,
        image_2: param.image2 ? param.image2.id : undefined,
        image_3: param.image3 ? param.image3.id : undefined,
      }, res => {
        this.dispatch("jobs", "updateJob", {job: res.data})
      });
    },
    saveJob (id, param) {
      return this.putRequest(`/companies/${this.companyId}/jobs/${id}/draft`, {
        ...param,
        name: param.name === "" ? null : param.name,
        image1: undefined,
        image2: undefined,
        image3: undefined,
        image_1: param.image1 === undefined ? undefined : param.image1 ? param.image1.id : null,
        image_2: param.image2 === undefined ? undefined : param.image2 ? param.image2.id : null,
        image_3: param.image3 === undefined ? undefined : param.image3 ? param.image3.id : null,
      }, res => {
        this.dispatch("jobs", "updateJob", {job: {...res.data, param}})
      });
    },
    saveJobImage (id, file) {
      // todo 使っているか要確認、使ってなさそう
      const formData = new FormData();
      formData.append("file", file);
      return this.putFormDataRequest(`/companies/${this.companyId}/jobs/${id}/upload-image`, formData, file.type, () => {
        // this.dispatch("client", "updateCompanyLogo", {logoUrl: res.data.logo});
      })
    },
    loadJobs () {
      return this.getRequest('/jobs', {}, res => {
        this.dispatch("jobs", 'updateJobs', res.data.jobs)
      })
    },
    loadRandomJobs (jobId, limit) {
      return this.getRequest(`/jobs/${jobId}/recommend`, {limit:limit}, res => {
        this.dispatch("jobs", 'updateRandomJobs', res.data.jobs)
      })
    },
    loadJob (jobId, draft = false) {
      if (draft) {
        return this.getRequest(`/companies/${this.companyId}/jobs/${jobId}/draft`, {},res => {
          this.dispatch("jobs", "updateJob", {job: res.data})
        });
      }
      return this.getRequest(`/companies/${this.companyId}/jobs/${jobId}`, {},res => {
        this.dispatch("jobs", "updateJob", {job: res.data})
      });
    },
    loadPagedJobs (page, salary = null, area = [], prefectures = {}, keyword = null, jobType = undefined) {
      return this.getRequest(`/jobs`, {
        page: page,
        salary: salary,
        area: area.length > 0 ? area.join(",") : null,
        prefectures: prefectures.length > 0 ? prefectures.join(",") : null,
        kw: keyword,
        jobType
      }, res => {
       this.dispatch("jobs", "updatePagedJobs", {jobs: res.data})
      });
    },
    loadPagedRecommendJobs (page, jobType = undefined) {
      const filterType = 'recommend'
      return this.getRequest(`/jobs`, {
        page: page,
        filterType,
        jobType
      }, res => {
        this.dispatch("jobs", "updatePagedRecommendJobs", {jobs: res.data})
      });
    },
    async searchJobs (page, jobType, occupation, salary, prefectures, keyword) {
      await this.getRequest('/jobs', {
        page,
        filterType: "search",
        jobType,
        occupation,
        salary,
        prefectures: prefectures.length > 0 ? prefectures.join(',') : undefined,
        kw: keyword
      }, res => {
        this.dispatch("jobs", "updateSearchJobsResult", {result: res.data})
      })
    },
    loadLatestJobs (num) {
      return this.getRequest(`/jobs`, {limit: num}, res => {
        this.dispatch("jobs", "updateLatestJobs", {jobs: res.data.jobs})
      });
    },
    loadClientJobs (companyId, page = 1) {
      return this.getRequest(`/companies/${companyId}/jobs`, {page: page}, res => {
        this.dispatch("client", "updateJobs", {jobs: res.data})
      });
    },
    loadAllClientJobs (companyId) {
      return this.getRequest(`/companies/${companyId}/jobs`, {}, res => {
        this.dispatch("client", "updateAllJobs", {jobs: res.data.jobs})
      });
    },
    loadClientJob (jobId) {
      return this.getRequest(`/companies/${this.companyId}/jobs/${jobId}/draft`, {}, res => {
        this.dispatch("client", "updateJob", {job: res.data})
      });
    },
    loadUserFavoriteJobs (page = 1) {
      return this.getRequest(`/jobs`, {isLiked: 1, isDisplayed: 1, page: page}, res => {
        this.dispatch("user", "updateFavoriteJobs", {jobs: res.data})
      });
    },
    loadUserAppliedJobs (page = 1) {
      return this.getRequest(`/jobs`, {isApplied: 1, isDisplayed: 1, page: page}, res => {
        this.dispatch("user", "updateAppliedJobs", {jobs: res.data})
      });
    },
    loadUserHiddenJobs (page = 1) {
      return this.getRequest(`/jobs`, {isDisplayed: 0, page: page}, res => {
        this.dispatch("user", "updateHiddenJobs", {jobs: res.data})
      });
    },
    async toggleLikeJob(jobId, status) {
      await this.putRequest(`/jobs/${jobId}/like`, {isLiked: status})
      this.dispatch("jobs", "updateLiked", {jobId, liked: status})
    },
    applyJob(jobId, userId,status) {
      return this.putRequest(`/jobs/${jobId}/apply`, {userId: userId, status: status}, () => {
       // this.dispatch("user", "updateJobs", {jobs: res.data.jobs})
      });
    },
    applyJobForClient(jobId, userId,status) {
      return this.putRequest(`/companies/${this.companyId}/jobs/${jobId}/manage`, {userId: userId, status: status}, () => {
        // this.dispatch("user", "updateJobs", {jobs: res.data.jobs})
      });
    },
    async saveMemoForClient(jobId, userId, memo) {
      await this.putRequest(`/companies/${this.companyId}/jobs/${jobId}/memo`, {userId, memo})
      this.dispatch('client', 'updateCandidateUserMemo', {userId, memo})
    },
    submitJoinSchedule(jobId, userId, status, joinSchedule) {
      return this.putRequest(`/companies/${this.companyId}/jobs/${jobId}/manage`, {userId: userId, status: status, meta: {joinSchedule: joinSchedule}})
    },
    submitJoinSideJob(jobId, userId, status, hourlyWage, workingHoursWeek, contractSchedule) {
      return this.putRequest(`/companies/${this.companyId}/jobs/${jobId}/manage`, {
        userId: userId,
        status: status,
        meta: {
          hourlyWage: hourlyWage,
          workingHoursWeek: workingHoursWeek,
          contractSchedule: contractSchedule
        }})
    },
    toggleHiddenJob(jobId, status) {
      return this.putRequest(`/jobs/${jobId}/display`, {isDisplayed: status})
    },
    loadCandidateUsers (id, page, jobId, applicationStatus, order, direction) {
      if (direction === 'asc') {
        order += "Asc"
      }
      this.getRequest(`/companies/${id}/users`, {client: 1, page: page, jobId, applicationStatus, order}, res => {
        this.dispatch("client", "updateCandidateUsers", {candidateUsers: res.data})
      })
    },
    async downloadCandidateUserCsv(companyId, messageIds, filename, encoding) {
      const { data: content } = await this.getRequest(`/companies/${companyId}/users/csv`, {messageId: messageIds, encoding: 'utf8'})

      const getUtf8Blob = (content) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
        return new Blob([bom, content], {type: 'application/octet-stream'});
      }

      const getSjisBlob = (content) => {
        const codes = Encoding.stringToCode(content);
        const shiftJisCodeList = Encoding.convert(codes, 'sjis', 'Unicode');
        const uInt8List = new Uint8Array(shiftJisCodeList);
        return new Blob([uInt8List], {type: 'text/plain'})
      }

      const url = window.URL.createObjectURL(encoding === 'utf8' ? getUtf8Blob(content) : getSjisBlob(content))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },
    // Payment
    loadPayments () {
      return this.getRequest(`/payments`, {},res => {
        this.dispatch("client", "updatePayments", {payments: res.data.payments})
      });
    },
    loadProducts () {
      return this.getRequest(`/products`, {},res => {
        this.dispatch("client", "updateProducts", {products: res.data.products})
      });
    },
    createPayment(params) {
      return this.postRequest('/payments', params, () => {
        this.dispatch("client", "updateUsedMf", {usedMf: "True"})
      })
    },
    // Images
    loadImages() {
      return this.getRequest(`/images`, {},res => {
        this.dispatch("client", "updateImages", {images: res.data.images})
      });
    },
    uploadImage (file) {
      const formData = new FormData();
      formData.append("file", file);
      return this.postFormDataRequest(`/images`, formData, file.type, res => {
        this.dispatch("client", "addImage", {image: res.data});
      })
    },
    deleteImage(id) {
      return this.delRequest(`/images/${id}`, {}, () => {
        this.dispatch("client", "removeImage", {id: id})
      })
    },
    // Competitions
    loadCompetitions(id) {
      return this.getRequest(`/users/${id}/competitions`, {service: 'connect'}, res => {
        this.dispatch("competitions", "updateList", {competitions: res.data.competitions})
      })
    },
    updateCompetitionShowResult(userId, competitionId, showResult) {
      return this.putRequest(
        `/competitions/${competitionId}/users/${userId}`,
        {
          showResult: showResult
        },
        () => {
          this.dispatch("competitions", "updateShowResult", {competitionId: competitionId, showResult: showResult})
        }
      )
    },

    // Messages
    loadUserMessages(id) {
      return this.getRequest(`/users/${id}/messages`, {}, res => {
        this.dispatch("message", "fetchUserMessages", {messages:  res.data.messages, unreadTotal: res.data.unreadTotal})
      })
    },
    loadCompanyMessages(id) {
      return this.getRequest(`/companies/${id}/messages`, {}, res => {
        this.dispatch("message", "fetchCompanyMessages", {actives:  res.data.active, inactives: res.data.inactive})
      })
    },
    updateMessageStatus(id, status) {
      return this.putRequest(`/messages/${id}`, {status: status}, () => {
        this.dispatch("message", "updateStatus", {id: id, status: status})
      })
    },
    loadMessageUtterances(id) {
      this.dispatch("message", "fetchUtterances", {utterances: []})
      return this.getRequest(`/messages/${id}/utterances`, {}, res => {
        this.dispatch("message", "fetchUtterances", {utterances: res.data.utterances})
      })
    },
    postCandidateUtterance(id, detail, dataId, option) {
      return this.postUtterance(id, detail, dataId, 1, option)
    },
    postClientUtterance(id, detail, dataId, option) {
      return this.postUtterance(id, detail, dataId, 2, option)
    },
    postUtterance(id, detail, dataId, whose, options = {}) {
      return this.postRequest(`/messages/${id}/utterances`, {
        detail: detail,
        data: dataId,
        whose: whose,
      }, res => {
        const notAddUtterance = options.notAddUtterance || false // メッセージ送信時にお見送りにした時、メッセージ側が新しく切り替わった後、お見送りメッセージが違う人のやりとりの下に追加されるのを防ぐためオプションを追加
        if (!notAddUtterance) {
          this.dispatch("message", "addUtterance", {
            utterance: res.data
          })
        }
      })
    },
    updateUtteranceIsRead(id, utteranceId, whose, isRead) {
      return this.putRequest(`/messages/${id}/utterances/${utteranceId}`, {whose: whose, isRead: isRead}, () => {
        this.dispatch("message", "updateIsRead", {id: id, utteranceId: utteranceId, isRead: isRead})
      })
    },
    // Chat Request
    loadCompaniesMe() {
      return this.getRequest(`/companies/me`, {}, res => {
        this.dispatch("chatRequests", "updateCompany", {company: res.data})
      })
    },
    loadChatRequestTargetJobs(companyId) {
      return this.getRequest(`/companies/${companyId}/jobs`, {onlyDisclosed: true}, res => {
        this.dispatch("chatRequests", "updateJobs", {jobs: res.data.jobs})
      })
    },
    saveChatRequestSearchConditions(companyId, name, conditions) {
      const query = queryString.stringify(conditions)
      return this.postRequest(`/companies/${companyId}/queries`, {name: name, query: query}, res => {
        this.dispatch("chatRequests", "addSearchConditionSet", {conditions: {
            id: res.data.id,
            name: res.data.name,
            conditions: queryString.parse(res.data.query)
          }})
      })
    },
    updateChatRequestSearchConditions(companyId, conditionId, name, conditions) {
      const query = conditions ? queryString.stringify(conditions) : undefined
      return this.putRequest(`/companies/${companyId}/queries/${conditionId}`, {name: name, query: query}, res => {
        this.dispatch("chatRequests", "updateSearchConditionSet", {conditions: {
            id: res.data.id,
            name: res.data.name,
            conditions: queryString.parse(res.data.query)
          }})
      })
    },
    deleteChatRequestSearchConditions(companyId, conditionsId) {
      return this.delRequest(`/companies/${companyId}/queries/${conditionsId}`, {}, () => {
        this.dispatch("chatRequests", "deleteSearchConditionSet", {conditionId: conditionsId})
      })
    },
    loadChatRequestSearchConditions(companyId) {
      return this.getRequest(`/companies/${companyId}/queries`, {}, res => {
        const conditionSets = res.data.queries.map(query => ({
          id: query.id,
          name: query.name,
          conditions: queryString.parse(query.query)
        }))
        this.dispatch("chatRequests", "updateSearchConditionSets", {conditionsSets: conditionSets})
      })
    },
    loadChatRequestApplicants(jobId, page, andKeyword, orKeyword, data, dataType, currentLocation, location, job, ageFrom, ageTo, medalist, salaryFrom, salaryTo, gender, newcomer, scoutable) {
      if (jobId) {
        return this.getRequest(`/jobs/${jobId}/candidates`, {
          page,
          kwAnd: andKeyword,
          kwOr: orKeyword,
          data: data.join(','),
          dataOrSearch: dataType === 'or',
          prefectures: currentLocation.join(','),
          locations: location.join(','),
          currentJobs: job.join(','),
          ageFrom,
          ageTo,
          medalist,
          salaryFrom,
          salaryTo,
          gender,
          newcomer,
          scoutable,
        }, res => {
          this.dispatch("chatRequests", "updateApplicants", {applicants: res.data})
        })
      }
    },
    loadChatRequestRequestedApplicants(jobId, page) {
      if (jobId) {
        return this.getRequest(`/jobs/${jobId}/candidates`, {
          page,
          filter: 'requested'
        }, res => {
          this.dispatch("chatRequests", "updateApplicants", {applicants: res.data})
        })
      }
    },
    loadChatRequestLists(companyId) {
      return this.getRequest(`/companies/${companyId}/candidate-lists`, {}, (res) => {
        this.dispatch("chatRequests", "updateLists", {lists: res.data.candidateLists})
      })
    },
    createChatRequestList(companyId, name) {
      return this.postRequest(`/companies/${companyId}/candidate-lists`, {name: name}, (res) => {
        this.dispatch("chatRequests", "createList", {list: res.data})
      })
    },
    updateChatRequestList(companyId, listId, name) {
      return this.putRequest(`/companies/${companyId}/candidate-lists/${listId}`, {name}, () => {
        this.dispatch("chatRequests", "editList", {listId: listId, name})
      })
    } ,
    deleteChatRequestList(companyId, listId) {
      return this.delRequest(`/companies/${companyId}/candidate-lists/${listId}`, {}, () => {
        this.dispatch("chatRequests", "deleteList", {listId: listId})
      })
    },
    addChatRequestListApplicant(companyId, userId, listId, listName) {
      return this.putRequest(`/companies/${companyId}/candidate-lists/${listId}/append`, {userId: userId}, () => {
        this.dispatch("chatRequests", "addListApplicant", {userId: userId, listId: listId})
        if (listName) {
          this.dispatch("system", "showSuccess", {message: `${listName}リストに追加しました`})
        }
      })
    },
    deleteChatRequestListApplicant(companyId, userId, listId) {
      return this.putRequest(`/companies/${companyId}/candidate-lists/${listId}/remove`, {userId: userId}, () => {
        this.dispatch("chatRequests", "deleteListApplicant", {userId: userId, listId: listId})
      })
    },
    putBusinessCandidateDisplay(userId) {
      return this.putRequest(`/business-candidates/display`, {userId: userId, isDisplay: true}, () => {
        this.dispatch("chatRequests", "updateDisplay", {userId: userId, isDisplay: true})
      })
    },
    putHotListCandidateIgnore(jobId, userId) {
      return this.putRequest(`/jobs/${jobId}/candidates/hot-list`, {userId}, () => {
        this.dispatch("chatRequests", "deleteListApplicant", {userId, listId: "hotList"})
      })
    },
    loadChatRequestListApplicants(jobId, listId, page) {
      if (jobId) {
        return this.getRequest(`/jobs/${jobId}/candidates`, {
          listId: listId,
          page: page
        }, res => {
          this.dispatch("chatRequests", "updateApplicants", {applicants: res.data})
        })
      }
    },
    loadChatRequestSignalListApplicants(jobId, page) {
      if (jobId) {
        return this.getRequest(`/jobs/${jobId}/candidates/hot-list`, {page}, res => {
          this.dispatch("chatRequests", "updateApplicants", {applicants: res.data})
        })
      }
    },
    sendChatRequest(companyId, requestorId, jobId, userId, reason, wantKnown) {
      return this.postRequest(`/companies/${companyId}/requests`, {job: jobId, user: userId, motivations: reason, interestId: wantKnown, requestor: requestorId}, () => {
        this.loadCompaniesMe()
        this.dispatch("chatRequests", "updateChatRequest", {userId: userId, reasons: reason, wantKnown: wantKnown})
      })
    },
    sendChatRequestWithMessage(companyId, requestorId, jobId, userId, message, skills, scoutMotivations) {
      return this.postRequest(`/companies/${companyId}/requests`, {job: jobId, user: userId, message: message, attractiveSkills: skills, requestor: requestorId, scoutMotivations: scoutMotivations}, () => {
        this.loadCompaniesMe()
        this.dispatch("chatRequests", "updateChatRequest", {job: jobId, userId: userId, message: message, attractiveSkills: skills, requestor: requestorId, scoutMotivations: scoutMotivations})
      })
    },
    loadUnprocessedOffers(userId) {
      return this.getRequest(`/users/${userId}/requests`, {isAccepted: false, isHidden: false}, res => {
        this.dispatch("user", "updateUnprocessedOffers", {offers: res.data.requests})
      })
    },
    loadRequestors(companyId) {
      this.getRequest(`/companies/${companyId}/requestors`, {}, res => {
        this.dispatch('client', 'updateRequestors', {requestors: res.data.requestors})
      })
    },
    async saveRequestor(companyId, requestorId, firstName, lastName, post) {
      if (requestorId) {
        const response = await this.putRequest(`/companies/${companyId}/requestors/${requestorId}`, {
          firstName,
          lastName,
          post,
        })
        this.dispatch('client', 'updateRequestor', {requestor: response.data})
        return response.data
      }
      const response = await this.postRequest(`/companies/${companyId}/requestors`, {
        firstName,
        lastName,
        post,
      })
      this.dispatch('client', 'updateRequestor', {requestor: response.data})
      return response.data
    },
    async deleteRequestor(companyId, requestorId) {
      await this.delRequest(`/companies/${companyId}/requestors/${requestorId}`, )
      this.dispatch('client', 'deleteRequestor', {requestorId: requestorId})
    },
    async uploadRequestorImage(companyId, requestorId, file) {
      const formData = new FormData();
      formData.append("file", file);
      const response = await this.putFormDataRequest(`/companies/${companyId}/requestors/${requestorId}/image`, formData, file.type)
      this.dispatch('client', 'updateRequestorImage', {requestorId, imageUrl: response.data.imageUrl})
    },
    async addMessageTemplate(companyId, name, detail) {
      const response = await this.postRequest(`/companies/${companyId}/message-templates`, {name, detail})
      this.dispatch("message", "addTemplate", {template: response.data})
    },
    async addScoutMessageTemplate(companyId, name, detail) {
      const response = await this.postRequest(`/companies/${companyId}/message-templates`, {name, detail, type: 2})
      this.dispatch("message", "addScoutTemplate", {template: response.data})
    },
    async loadMessageTemplates(companyId) {
      const response = await this.getRequest(`/companies/${companyId}/message-templates`, {type: 1})
      this.dispatch("message", "updateTemplates", {templates: response.data.templates})
    },
    async loadScoutMessageTemplates(companyId) {
      const response = await this.getRequest(`/companies/${companyId}/message-templates`, {type: 2})
      this.dispatch("message", "updateScoutTemplates", {templates: response.data.templates})
    },
    async saveMessageTemplate(companyId, templateId, name, detail) {
      const response = await this.putRequest(`/companies/${companyId}/message-templates/${templateId}`, {name, detail})
      this.dispatch("message", "updateTemplate", {template: response.data})
    },
    async saveScoutMessageTemplate(companyId, templateId, name, detail) {
      const response = await this.putRequest(`/companies/${companyId}/message-templates/${templateId}`, {name, detail, type: 2})
      this.dispatch("message", "updateScoutTemplate", {template: response.data})
    },
    async deleteMessageTemplate(companyId, templateId) {
      await this.delRequest(`/companies/${companyId}/message-templates/${templateId}`)
      this.dispatch("message", "removeTemplate", {templateId})
    },
    async deleteScoutMessageTemplate(companyId, templateId) {
      await this.delRequest(`/companies/${companyId}/message-templates/${templateId}`, {type: 2})
      this.dispatch("message", "removeScoutTemplate", {templateId})
    },

    // Utilities
    dispatch (module, action, params) {
      this.$store.dispatch(`${module}/${action}`, params);
    },
    getRequest (url, params, success, failed, silent) {
      return get(url, params, this.token(), (res) => {
        if (success) {
          success(res);
        }
      }, (res) => {
        this.handleError(res);
        if (failed) {
          failed(res);
        }
      }, silent)
    },
    postRequest (url, data, success, failed, silent) {
      return post(url, data, this.token(), (res) => {
        if (success) {
          success(res);
        }
      }, (res) => {
        this.handleError(res);
        if (failed) {
          failed(res);
        }
      }, silent)
    },
    putRequest (url, data, success, failed, silent) {
      return put(url, data, this.token(), (res) => {
        if (success) {
          success(res);
        }
      }, (res) => {
        this.handleError(res);
        if (failed) {
          failed(res);
        }
      }, silent)
    },
    delRequest (url, data, success, failed, silent) {
      return del(url, data, this.token(), (res) => {
        if (success) {
          success(res);
        }
      }, (res) => {
        this.handleError(res);
        if (failed) {
          failed(res);
        }
      }, silent)
    },
    postFormDataRequest (url, data, contentType, success, failed, silent) {
      return postFormData(url, data, contentType, this.token(), (res) => {
        if (success) {
          success(res);
        }
      }, (res) => {
        this.handleError(res);
        if (failed) {
          failed(res);
        }
      }, silent)
    },
    putFormDataRequest (url, data, contentType, success, failed, silent) {
      return putFormData(url, data, contentType, this.token(), (res) => {
        if (success) {
          success(res);
        }
      }, (res) => {
        this.handleError(res);
        if (failed) {
          failed(res);
        }
      }, silent)
    },
    handleError (res) {
      if (res && res.response) {
        if (res.response.status === 401) {
          this.dispatch("system", "showError", {message: this.msg("requiredLogin")});
          this.logout();
        }
      }
    },
    msg (key) {
      return this.$t(`commons.labels.${key}`);
    },
    token () {
      if (!this.$auth || !this.$auth.isAuthenticated) {
        return null;
      }
      return this.$auth.getTokenSilently();
    }
  }
};
